import { Link } from "@tanstack/react-router";
import { Button } from "@provenleap/ui";
import { ArrowRight } from "@phosphor-icons/react";
import { Header } from "./Header";
import { HeroSection } from "./HeroSection";
import { PillarsSection } from "./PillarsSection";
import { FeaturesSection } from "./FeaturesSection";
import { IntegrationsSection } from "./IntegrationsSection";
import { PricingSection } from "./PricingSection";
import { FAQSection } from "./FAQSection";

import { SectionArrow } from "./SectionArrow";
import { BackgroundGlows } from "./BackgroundGlows";
import { Footer } from "./Footer";
import { JsonLd } from "../../seo/JsonLd";
import { faqPageSchema, softwareApplicationSchema } from "../../seo/schemas";
import { HOMEPAGE_FAQS } from "../../data/faqs";

export function LandingPage() {
  return (
    <div className="landing-page min-h-screen bg-white relative overflow-hidden" id="top">
      {/* Structured data (Story 30.4): SoftwareApplication (offers from PLAN_PRICING)
          + FAQPage (from the same HOMEPAGE_FAQS the visible accordion renders). */}
      <JsonLd data={softwareApplicationSchema()} />
      <JsonLd data={faqPageSchema(HOMEPAGE_FAQS)} />
      <BackgroundGlows />
      {/* Skip to content link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg focus:text-brand focus:text-sm focus:font-medium"
      >
        Skip to content
      </a>

      <Header />

      <main id="main-content" className="relative">
        <HeroSection />
        <PillarsSection />
        {/* Below-the-fold sections skip off-screen render work (Story 30.5
            content-visibility) — never the hero/pillars (above the fold). */}
        <div className="cv-auto">
          <FeaturesSection />
        </div>
        <div className="cv-auto">
          <IntegrationsSection />
        </div>
        <div className="cv-auto">
          <PricingSection />
        </div>
        <div className="cv-auto">
          <FAQSection />
        </div>

        {/* Final CTA */}
        <div className="py-10 sm:py-16">
          <div className="max-w-[640px] mx-auto px-3 sm:px-8 text-center">
            <SectionArrow />
            <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
              Ready to impress your clients?
            </h2>
            <p className="mt-4 text-lg text-foreground/85">
              Be among the first agencies to use ProvenLeap and get all
              features included from day one.
            </p>
            <Button asChild variant="brand" size="lg" className="mt-8 min-h-11 px-8 text-base rounded-2xl">
              <Link to="/waitlist">
                Join Waitlist
                <ArrowRight size={16} className="ml-2" />
              </Link>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
